import { useBrand } from '@/shared/lib/brand';
import { cn } from '@/shared/lib/cn';

interface BrandMarkProps {
  /** Tamanho do ícone quadrado (px). */
  iconSize?: number;
  /** Altura do logotipo horizontal (px). */
  wordmarkSize?: number;
  /** Espaço entre ícone e logotipo (px). */
  gap?: number;
  className?: string;
}

/** Ícone + logotipo da marca ativa (Host / partner). */
export function BrandMark({
  iconSize = 36,
  wordmarkSize = 23,
  gap = 10,
  className,
}: BrandMarkProps) {
  const { brand } = useBrand();
  const displayWordmarkSize = Math.round(wordmarkSize * brand.logotypeScale);
  const wordmarkWidth = Math.round(displayWordmarkSize * brand.logotypeAspect);

  return (
    <div
      className={cn('inline-flex min-w-0 items-center', className)}
      role="img"
      aria-label={brand.displayName}
    >
      <img
        src={brand.assets.icon.brand}
        alt=""
        width={iconSize}
        height={iconSize}
        decoding="async"
        className="shrink-0 object-contain"
        style={{ width: iconSize, height: iconSize }}
      />
      <div
        className="relative shrink-0"
        style={{ width: wordmarkWidth, height: displayWordmarkSize, marginLeft: gap }}
      >
        <img
          src={brand.assets.logotype.light}
          alt=""
          width={wordmarkWidth}
          height={displayWordmarkSize}
          decoding="async"
          className="absolute inset-0 h-full w-full object-contain object-left dark:hidden"
          style={{ filter: brand.assets.logotype.lightFilter }}
        />
        <img
          src={brand.assets.logotype.dark}
          alt=""
          width={wordmarkWidth}
          height={displayWordmarkSize}
          decoding="async"
          className="absolute inset-0 hidden h-full w-full object-contain object-left dark:block"
        />
      </div>
    </div>
  );
}

/** Defaults numéricos da sidebar (aspecto vem de `useBrand().brand.logotypeAspect`). */
export const BRAND_MARK_DEFAULTS = {
  iconSize: 36,
  wordmarkSize: 23,
  gap: 10,
} as const;
